const account_center = {
    home: {
        title: 'Сторінку не знайдено',
        description: 'Ця сторінка недоступна.',
    },
    page: {
        title: 'Акаунт',
        security_title: 'Безпека',
        security_description: 'Тут можна змінити налаштування акаунта, щоб забезпечити його безпеку.',
        profile_title: 'Особиста інформація',
        profile_description: 'Змініть свою особисту інформацію тут.',
        sidebar_personal_info: 'Особиста інформація',
        sidebar_security: 'Безпека',
        sidebar_sessions: 'Сесії',
        support: 'Підтримка',
        user_menu: 'Меню користувача',
        sign_out: 'Вийти',
    },
    verification: {
        error_send_failed: 'Не вдалося надіслати код підтвердження. Спробуйте ще раз пізніше.',
        error_invalid_code: 'Код підтвердження недійсний або строк його дії минув.',
        error_verify_failed: 'Не вдалося підтвердити. Будь ласка, введіть код ще раз.',
        step_up_not_completed: 'Підтвердження особи не завершено. До вашого облікового запису не внесено жодних змін.',
    },
    email: {
        title: "Прив'язати email",
        description: "Прив'яжіть свій email, щоб входити або допомогти з відновленням облікового запису.",
        verification_title: 'Введіть код підтвердження email',
        verification_description: 'Код підтвердження надіслано на ваш email {{email_address}}.',
        success: "Основний email успішно прив'язано.",
    },
    phone: {
        title: "Прив'язати телефон",
        description: "Прив'яжіть номер телефону, щоб увійти або допомогти з відновленням облікового запису.",
        verification_title: 'Введіть код підтвердження SMS',
        verification_description: 'Код підтвердження надіслано на ваш телефон {{phone_number}}.',
        success: "Основний телефон успішно прив'язано.",
    },
    username: {
        title: "Встановити ім'я користувача",
        description: "Ім'я користувача може містити лише літери, цифри та символи підкреслення.",
        policy_description: '{{requirements}}',
        success: "Ім'я користувача успішно оновлено.",
    },
    security: {
        add: 'Додати',
        change: 'Змінити',
        remove: 'Видалити',
        not_set: 'Не встановлено',
        social_sign_in: 'Соціальний вхід',
        social_not_linked: 'Не прив’язано',
        email_phone: 'Електронна пошта / Телефон',
        email: 'Електронна пошта',
        phone: 'Телефон',
        password: 'Пароль',
        configured: 'Налаштовано',
        not_configured: 'Не налаштовано',
        two_step_verification: 'Двоетапна перевірка',
        authenticator_app: 'Додаток для автентифікації',
        passkeys: 'Passkeys',
        backup_codes: 'Резервні коди',
        email_verification_code: 'Код підтвердження електронної пошти',
        phone_verification_code: 'Код підтвердження телефону',
        passkeys_count_one: '{{count}} passkey',
        passkeys_count_other: '{{count}} passkeys',
        backup_codes_count_one: '{{count}} код залишився',
        backup_codes_count_other: '{{count}} кодів залишилось',
        view: 'Перегляд',
        manage: 'Керування',
        turn_on_2_step_verification_description: 'Додайте додатковий рівень безпеки. При вході вам буде запропоновано другий крок верифікації.',
        two_step_verification_incomplete_description: 'Двоетапна верифікація ввімкнена, але ще не діє.',
        two_step_verification_off_description: 'Ваш вибір двоетапної верифікації вимкнено. Додаткова верифікація може й надалі вимагатися політиками безпеки.',
        turn_off_2_step_verification: 'Вимкнути двоетапну верифікацію',
        turn_off_2_step_verification_description: 'Вимкнення двоетапної верифікації видалить додатковий рівень захисту вашого облікового запису при вході. Ви впевнені, що хочете продовжити?',
        disable_2_step_verification: 'Вимкнути',
        no_verification_method_warning: 'Налаштування не завершено. Додайте спосіб верифікації нижче, щоб завершити налаштування двоетапної верифікації.',
        two_step_verification_load_failed: 'Не вдалося завантажити налаштування двоетапної верифікації. Спробуйте ще раз.',
        two_step_verification_retry: 'Повторити',
        passkey_sign_in_prompt: 'Пропонувати налаштувати passkey',
        passkey_sign_in_prompt_description: 'Коли ввімкнено, вам буде запропоновано налаштувати passkey для швидшого та безпечнішого входу.',
        account_removal: 'Видалення акаунта',
        delete_your_account: 'Видаліть свій акаунт',
        delete_account: 'Видалити акаунт',
        remove_username_confirmation_title: "Видалити ім'я користувача",
        remove_username_confirmation_description: 'Після видалення ви більше не зможете входити за допомогою цього імені користувача. Ви впевнені, що хочете продовжити?',
        remove_email_confirmation_title: 'Видалити адресу електронної пошти',
        remove_email_confirmation_description: 'Після видалення ви більше не зможете входити за допомогою цієї адреси електронної пошти. Ви впевнені, що хочете продовжити?',
        remove_phone_confirmation_title: 'Видалити номер телефону',
        remove_phone_confirmation_description: 'Після видалення ви більше не зможете входити за допомогою цього номера телефону. Ви впевнені, що хочете продовжити?',
        email_removed: 'Адресу електронної пошти успішно видалено.',
        phone_removed: 'Номер телефону успішно видалено.',
        username_removed: "Ім'я користувача успішно видалено.",
        trusted_devices: {
            title: 'Довірені пристрої MFA',
            current_device: 'Поточний пристрій',
            expires_on: 'Термін дії до {{date}}',
            unknown_location: 'Невідоме розташування',
            remove: 'Видалити',
            removed: 'Довірений пристрій успішно видалено.',
            loading: 'Завантаження...',
            empty: 'Немає довірених пристроїв.',
            load_failed: 'Не вдалося завантажити довірені пристрої. Спробуйте ще раз.',
            retry: 'Спробувати ще раз',
            remove_confirmation_title: 'Видалити довірений пристрій?',
            remove_confirmation_description: 'Під час наступного входу на цьому пристрої вам потрібно буде знову пройти MFA. Поточний сеанс залишиться активним.',
        },
        personal_access_tokens: {
            title: 'Особисті токени доступу',
            description: 'Використовуйте особисті токени доступу для автентифікації в API від вашого імені. Вони залишаються активними, доки не закінчиться термін їхньої дії або ви їх не відкличете, навіть якщо ви вийдете з облікового запису чи зміните пароль.',
            create: 'Створити новий токен',
            created_at: 'Створено {{date}}',
            expires_on: 'Діє до {{date}}',
            expired_on: 'Термін дії закінчився {{date}}',
            expired: 'Прострочено',
            never_expires: 'Безстроковий',
            never_expires_warning: 'Цей токен не має терміну дії. Для кращої безпеки створіть новий токен із терміном дії та відкличте цей.',
            rename: 'Перейменувати',
            revoke: 'Відкликати',
            loading: 'Завантаження...',
            empty: 'Немає особистих токенів доступу.',
            load_failed: 'Не вдалося завантажити особисті токени доступу. Спробуйте ще раз.',
            retry: 'Спробувати ще раз',
            create_modal_title: 'Створити особистий токен доступу',
            create_modal_description: 'Надайте токену описову назву та виберіть термін дії.',
            token_name: 'Назва токена',
            token_name_placeholder: 'Мій токен',
            expiration: 'Термін дії',
            expiration_days: '{{count}} дн.',
            created_modal_title: 'Особистий токен доступу створено',
            show_once_warning: 'Ви більше не зможете побачити цей токен. Скопіюйте його зараз і збережіть у надійному місці.',
            copied: 'Особистий токен доступу скопійовано.',
            rename_modal_title: 'Перейменувати особистий токен доступу',
            rename_modal_description: 'Введіть нову назву для цього особистого токена доступу.',
            renamed: 'Особистий токен доступу успішно перейменовано.',
            revoke_confirmation_title: 'Відкликати особистий токен доступу?',
            revoke_confirmation_description: 'Будь-які застосунки чи скрипти, що використовують «{{name}}», негайно втратять доступ. Ви впевнені, що хочете продовжити?',
            revoked: 'Особистий токен доступу успішно відкликано.',
        },
    },
    social: {
        linked: '{{connector}} успішно прив’язано.',
        not_enabled: 'Цей спосіб входу через соціальну мережу не ввімкнено. Будь ласка, зверніться до адміністратора по допомогу.',
        removed: '{{connector}} успішно видалено.',
        remove_confirmation_title: 'Видалити соціальний акаунт',
        remove_confirmation_description: 'Якщо ви видалите {{connector}}, можливо, ви не зможете входити через нього, доки не додасте його знову.',
    },
    password: {
        title: 'Встановити пароль',
        description: 'Створіть новий пароль, щоб захистити свій обліковий запис.',
        success: 'Пароль успішно оновлено.',
    },
    code_verification: {
        send: 'Надіслати код підтвердження',
        resend: 'Ще не отримали? <a>Надіслати код підтвердження ще раз</a>',
        resend_countdown: 'Ще не отримали? Повторна відправка через {{seconds}} с.',
    },
    email_verification: {
        email_label: 'Адреса електронної пошти',
    },
    phone_verification: {
        phone_label: 'Номер телефону',
    },
    mfa: {
        totp_already_added: 'Ви вже додали додаток для автентифікації. Будь ласка, спочатку видаліть існуючий.',
        totp_not_enabled: 'Додаток для автентифікації OTP не увімкнено. Зверніться до адміністратора за допомогою.',
        backup_code_already_added: 'У вас вже є активні резервні коди. Будь ласка, використайте або видаліть їх перед створенням нових.',
        backup_code_not_enabled: 'Резервний код не увімкнено. Зверніться до адміністратора за допомогою.',
        backup_code_requires_other_mfa: 'Резервні коди вимагають попереднього налаштування іншого методу MFA.',
        passkey_not_enabled: 'Passkey не увімкнено. Зверніться до адміністратора за допомогою.',
        passkey_already_registered: 'Цей passkey вже зареєстровано у вашому обліковому записі. Будь ласка, використовуйте інший автентифікатор.',
    },
    update_success: {
        default: {
            title: 'Оновлено!',
            description: 'Вашу інформацію було оновлено.',
        },
        email: {
            title: 'Електронну пошту оновлено!',
            description: 'Вашу електронну адресу успішно оновлено.',
        },
        phone: {
            title: 'Номер телефону оновлено!',
            description: 'Ваш номер телефону успішно оновлено.',
        },
        username: {
            title: "Ім'я користувача змінено!",
            description: "Ваше ім'я користувача успішно оновлено.",
        },
        password: {
            title: 'Пароль змінено!',
            description: 'Ваш пароль успішно оновлено.',
        },
        totp: {
            title: 'Додаток для автентифікації додано!',
            description: "Ваш додаток для автентифікації успішно під'єднано до вашого акаунту.",
        },
        totp_replaced: {
            title: 'Додаток для автентифікації замінено!',
            description: 'Ваш додаток для автентифікації було успішно замінено.',
        },
        backup_code: {
            title: 'Резервні коди створено!',
            description: 'Ваші резервні коди збережено. Зберігайте їх у безпечному місці.',
        },
        passkey: {
            title: 'Passkey додано!',
            description: "Ваш passkey успішно під'єднано до вашого облікового запису.",
        },
        social: {
            title: "Соціальний акаунт під'єднано!",
            description: "Ваш соціальний акаунт успішно під'єднано.",
        },
    },
    backup_code: {
        title: 'Резервні коди',
        description: 'Ви можете використати один з цих резервних кодів для доступу до свого облікового запису, якщо у вас виникнуть проблеми під час двоетапної перевірки іншими способами. Кожен код можна використати лише один раз.',
        copy_hint: "Обов'язково скопіюйте їх і збережіть у надійному місці.",
        generate_new_title: 'Згенерувати нові резервні коди',
        generate_new: 'Згенерувати нові резервні коди',
    },
    passkey: {
        title: 'Passkeys',
        added: 'Додано: {{date}}',
        last_used: 'Останнє використання: {{date}}',
        never_used: 'Ніколи',
        unnamed: 'Passkey без назви',
        renamed: 'Passkey успішно перейменовано.',
        deleted: 'Passkey успішно видалено.',
        add_another_title: 'Додати інший passkey',
        add_another_description: 'Зареєструйте свій passkey за допомогою біометрії пристрою, ключів безпеки (наприклад, YubiKey) або інших доступних методів.',
        add_passkey: 'Додати passkey',
        delete_confirmation_title: 'Видалити ваш passkey',
        delete_confirmation_description: 'Якщо ви видалите цей passkey, ви не зможете використовувати його для підтвердження.',
        rename_passkey: 'Перейменувати passkey',
        rename_description: 'Введіть нову назву для цього passkey.',
        name_this_passkey: 'Назвіть цей passkey пристрою',
        name_passkey_description: 'Ви успішно підтвердили цей пристрій для двоетапної автентифікації. Налаштуйте назву для розпізнавання, якщо у вас кілька ключів.',
        name_input_label: "Ім'я",
    },
    sessions: {
        page_title: 'Сесії',
        page_description: 'Керуйте активними сесіями та авторизованими сторонніми додатками.',
        title: 'Сесії',
        current_session: 'Поточна сесія',
        signed_in_at: 'Вхід виконано {{date}}',
        revoke_session: 'Вийти',
        revoke_session_title: 'Завершити сесію',
        revoke_session_description: "Це завершить сесію та відкличе весь пов'язаний доступ. Ви впевнені, що хочете продовжити?",
        no_other_sessions: 'Немає інших активних сесій.',
        loading: 'Завантаження...',
        third_party_apps_title: 'Сторонні додатки',
        no_third_party_apps: 'Немає авторизованих сторонніх додатків.',
        third_party_apps_load_failed: 'Не вдалося завантажити сторонні додатки. Спробуйте ще раз.',
        granted_at: 'Авторизовано {{date}}',
        dynamic_app: 'Динамічний додаток',
        client_id: 'Ідентифікатор клієнта: {{clientId}}',
        revoke_grant: 'Видалити',
        revoke_grant_title: 'Видалити доступ стороннього додатку',
        revoke_grant_description: 'Це відкличе доступ, наданий цьому додатку. Раніше видані токени доступу можуть залишатися дійсними до завершення строку їхньої дії. Ви впевнені, що хочете продовжити?',
        revoke_grant_failed: 'Не вдалося відкликати деякі дозволи. Будь ласка, спробуйте ще раз.',
    },
};
export default Object.freeze(account_center);
